import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";
import s1 from '../assets/image27.jpeg';
import s2 from '../assets/image28.jpeg';
import s3 from '../assets/image29.jpeg';
import s4 from '../assets/image30.jpeg';
import s5 from '../assets/banner1.png';

export default function View({ uuid }) {

  const appContext = useContext(AppContext);

  const staticNewsData = [
    {
      uuid: "news-001",
      title: "Mkutano Mkuu wa Mwaka (AGM) Kufanyika Mwezi Huu Kujadili Gawio la Hisa",
      coverPhoto: s1,
      description: "Wanachama wote wa YCSC SACCOS mnasasishwa kuhudhuria mkutano mkuu wa mwaka utakaofanyika kujadili ukuaji, kupitisha bajeti na kuigawa faida ya mwaka.",
      body: "<p>Wanachama wote wa YCSC SACCOS mnasasishwa kuhudhuria mkutano mkuu wa mwaka utakaofanyika kujadili ukuaji, kupitisha bajeti na kuigawa faida ya mwaka.</p>",
      created_at: "2026-06-15T10:00:00Z"
    },
    {
      uuid: "news-002",
      title: "YCSC SACCOS Sasa Yazindua Mfumo Mpya wa Kidijitali wa Maombi ya Mikopo",
      coverPhoto: s2,
      description: "Katika kurahisisha huduma zetu, sasa unaweza kuomba mkopo wa dharura au maendeleo moja kwa moja kupitia mfumo wetu mpya bila karatasi.",
      body: "<p>Katika kurahisisha huduma zetu, sasa unaweza kuomba mkopo wa dharura au maendeleo moja kwa moja kupitia mfumo wetu mpya bila karatasi.</p>",
      created_at: "2026-05-28T08:30:00Z"
    },
    // {
    //   uuid: "news-003",
    //   title: "Mafunzo Maalum ya Usimamizi wa Fedha na Uwekezaji kwa Wanachama Wapya",
    //   coverPhoto: s3,
    //   description: "Kamati ya elimu imeandaa semina ya siku moja kwa ajili ya kuwajengea uwezo wanachama juu ya namna bora ya kukuza biashara na kusimamia mikopo.",
    //   body: "<p>Kamati ya elimu imeandaa semina ya siku moja kwa ajili ya kuwajengea uwezo wanachama juu ya namna bora ya kukuza biashara na kusimamia mikopo.</p>",
    //   created_at: "2026-05-10T14:15:00Z"
    // },
    {
      uuid: "news-004",
      title: "Ukuaji wa Mtaji wa Chama: Akiba na Amana Zafikia Kiwango cha Juu Zaidi",
      coverPhoto: s4,
      description: "Ripoti ya robo mwaka inaonyesha ongezeko kubwa la ukwasi na amana za wanachama, jambo linalothibitisha uaminifu mkubwa ndani ya ushirika wetu.",
      body: "<p>Ripoti ya robo mwaka inaonyesha ongezeko kubwa la ukwasi na amana za wanachama, jambo linalothibitisha uaminifu mkubwa ndani ya ushirika wetu.</p>",
      created_at: "2026-04-18T11:00:00Z"
    },
    {
      uuid: "news-005",
      title: "Kurudisha kwa Jamii Wenye Uhitaji Kupitia YCSC Community Day",
      coverPhoto: s5,
      description: "Katika chama chetu, tunatambua umuhimu wa kugusa maisha ya wengine. Kila mwaka ifikapo mwezi wa pili, tunakuwa na siku rasmi ya kuwasaidia na kuwashika mkono wale wenye uhitaji katika jamii yetu.",
      created_at: "2026-04-18T11:00:00Z"
    }
  ];

  /* Place states here */
  const [ ready, setReady ] = useState(false);
  const [ data, setData ] = useState(null);

  async function init() {
    setReady(false);
    await Promise.all([
      getData(),
    ])
    setReady(true);
  }

  async function getData() {
    // Kutafuta habari inayolingana na uuid iliyopitishwa kwenye props
    const singleNews = staticNewsData.find(item => item.uuid === uuid);
    
    if (singleNews) {
      setData(singleNews);
    } else {
      setData(null);
    }

    // await callApi('get-news-data', { uuid }).then((response) => {
    //   if(response.status === 1) {
    //     setData(response.data);
    //   } else {
    //     appContext.tellError("Could not fetch data");
    //   }
    // })
  }

  useEffect(() => {
    init();
  }, [uuid]); // Ongeza uuid hapa ili ukurasa ujirudie upya ikiwa uuid itabadilika

  

  if (ready && data) {
    return (
      
      <div 
        className="container"
        
      >
        
    

        <div className="row">

          <div className="col-md-12">
            <h6
              className="main-section-title font-semi-bold"
            >
              {data.title}
            </h6>
          </div>

          
          <div className="col-md-12 mt-2 mb-2">
            <img
              src={data.coverPhoto}
              style={{
                width: "100%"
              }}
            />
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <h6
              style={{
                fontSize: "12px"
              }}
              className="text-end text-muted font-semi-bold"
            >
              {data.created_at}
            </h6>
            <hr/>
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <div
              className=""
              style={{
                width: "100%",
                padding: "0",
                overflow: "hidden",
              }}
              dangerouslySetInnerHTML={{ __html: data.body || data.description }}
            >

            </div>
          </div>
          
          
        </div>

        
      </div>
       
    );
  } else if (ready && !data) {
    return (
      <div className="container text-center py-5">
        <h6>Habari haikupatikana</h6>
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}